import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import './Header.css';

const Header = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  return (
    <header className="header">
      <div className="container header-container">
        <div className="logo-container">
          <Link to="/" className="logo">
            <img
                src={require('../../assets/images/logo.jpg')}
                alt="GBC Logo"
                className="logo-icon"
            />
            <div className="logo-text-wrapper">
                <span className="logo-text">GBC</span>
                <span className="logo-subtext">Global Business Combine</span>
            </div>
            </Link>
        </div>
        
        <div className="mobile-nav-toggle" onClick={toggleNav}>
          {isNavOpen ? <FaTimes /> : <FaBars />}
        </div>
        
        <nav className={`nav-menu ${isNavOpen ? 'active' : ''}`}>
            <ul className="nav-list">

                <li className="nav-item">
                <Link to="/" className="nav-link" onClick={() => setIsNavOpen(false)}>
                    Home
                </Link>
                </li>

                <li className="nav-item">
                <Link to="/about" className="nav-link" onClick={() => setIsNavOpen(false)}>
                    About Us
                </Link>
                </li>

                <li className="nav-item">
                <Link to="/products" className="nav-link" onClick={() => setIsNavOpen(false)}>
                    Products
                </Link>
                </li>

                {/* Services (Home anchor) */}
                <li className="nav-item">
                <Link to="/#services" className="nav-link" onClick={() => setIsNavOpen(false)}>
                    Services
                </Link>
                </li>

                {/* Catalogue (Google Drive PDF) */}
                <li className="nav-item">
                <a
                    href="https://drive.google.com/file/d/1mQe5U6VOFngkrss2H2a8duYqDujtJ-mZ/view"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="nav-link"
                    onClick={() => setIsNavOpen(false)}
                >
                    Catalogue
                </a>
                </li>

                <li className="nav-item">
                <Link to="/contact" className="nav-link" onClick={() => setIsNavOpen(false)}>
                    Contact
                </Link>
                </li>

            </ul>
            </nav>

      </div>
    </header>
  );
};

export default Header;
